import { Browser } from "@capacitor/browser";
import type { BrowserPort } from "./types";

/** 네이티브: Custom Tabs(@capacitor/browser). 약관·고객센터 노션·구글 폼. */
export const nativeBrowser: BrowserPort = {
  async open(url) {
    await Browser.open({ url });
  },
};
